export enum SpellTraditions {
    Arcane = 'Arcane',
    Divine = 'Divine',
    Occult = 'Occult',
    Primal = 'Primal',
    Focus = 'Focus',
}
